import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getSubZoneAvailableColumns } from './api';

export const path = '/subzone/list';

const PageSubZoneList: React.FC = (props) => {
  const SubZoneList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getSubZoneAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <SubZoneList {...props} />;
};

export default PageSubZoneList;
